/**
 * /app/$tenantSlug/me/security — old home of Me → Security. N1
 * (2026-10-21): the page is now the Security tab of Me → Account; this
 * route only redirects so bookmarks and old links keep working.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/me/security")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/$tenantSlug/me/account/security",
      params: { tenantSlug: params.tenantSlug },
      replace: true,
    });
  },
});
